import { Action, createReducer, on } from '@ngrx/store'
import { initialSettingsState, SettingsState } from '../state/settings.state'
import {
  fetch_company_setting_preferences_data_success,
  update_settings_success_action
} from '../action/settings.action'

export function settingsReducer(state: SettingsState, action: Action) {
  return _settingsReducer(state, action)
}

const _settingsReducer = createReducer(
  initialSettingsState,
  on(fetch_company_setting_preferences_data_success, (state, { companySettingPreferences }) => {
    return {
      ...state,
      communicationPreferences: companySettingPreferences.notificationPreferences,
      modules: companySettingPreferences.modules
    }
  }),
  on(update_settings_success_action, (state, { companySettingPreferences }) => {
    return {
      ...state,
      communicationPreferences: companySettingPreferences.notificationPreferences,
      modules: companySettingPreferences.modules
    }
  })
)
